import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  // Whitespace-nowrap: Badges should never wrap.
  "whitespace-nowrap inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2" +
  " hover-elevate " ,
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow-xs",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-xs",

        outline: " border [border-color:var(--badge-outline)] shadow-xs",

        // Variantes semânticas do sistema (Rizoma_UI_Spec.md §3.3). São QUATRO
        // + neutro, e não se usam soltas na página: quem as aplica é o
        // `StatusBadge` (components/data/status-badge.tsx). O raio continua
        // `rounded-md` — o pill dos mockups não é o raio deste sistema.
        sucesso: "border-transparent bg-sucesso-suave text-sucesso",
        atencao: "border-transparent bg-atencao-suave text-atencao",
        erro: "border-transparent bg-erro-suave text-erro",
        info: "border-transparent bg-info-suave text-info",
        neutro: "border-transparent bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants }
